import checkIfExternalLink from './checkIfExternalLink'
import slugify from 'slugify'

export default (link, isMultiLocationSite, city) => {
  if (link) {
    if (checkIfExternalLink(link)) {
      if (link.includes('sms') || link.includes('tel')) {
        return link
      }
      if (!link.includes('https') && !link.includes('http')) {
        return 'https://' + link
      }
      return link // i.e return (https://google.com) // for external links
    } else {
      if (city && slugify(city, { lower: true }) === slugify(link, { lower: true })) {
        return `/${slugify(city, { lower: true })}`
      } else {
        return isMultiLocationSite
          ? `/${slugify(city, { lower: true })}/${slugify(link, { lower: true })}` // i.e returns (milford/menu) // for multi location links
          : `/${slugify(link, { lower: true })}` //  i.e returns (menu) // for single location links
      }
    }
  } else if (link === '') {
    return '/' // if link empty string return to home
  }
}
